import { makeStyles } from '@rbx/ui';
import { getCustomMarkdownFontSize } from '@modules/layout/layout/constants/layoutConstants';

const useEnumCharacteristicsIteratorStyles = makeStyles<{ enableEngineReferenceRevamp: boolean }>()(
  (theme, { enableEngineReferenceRevamp }) => ({
    header: {
      '& .MuiTableCell-root': {
        fontSize: getCustomMarkdownFontSize(enableEngineReferenceRevamp),
        '&:first-child': {
          paddingLeft: 0,
        },
      },
    },
    row: {
      '& .MuiTableCell-root': {
        fontSize: getCustomMarkdownFontSize(enableEngineReferenceRevamp),
        verticalAlign: 'top',
        '&:first-child': {
          paddingLeft: 0,
        },
      },
    },
    rowAboveSummaryRow: {
      '& .MuiTableCell-root': {
        paddingBottom: 0,
        border: 'none',
      },
    },
    summaryRow: {
      '& .MuiTableCell-root': {
        paddingTop: 0,
      },
      '& .MuiTableCell-root p:last-child': {
        marginBottom: '0 !important',
      },
    },
    hasSummary: {
      '& .MuiTableCell-root': {
        paddingTop: `8px !important`,
      },
    },
    summary: {
      '& p:only-child, & p:last-child': {
        marginBottom: 0,
      },
    },
    value: {
      textAlign: 'center',
      paddingRight: '32px',
      [theme.breakpoints.down('Medium')]: {
        textAlign: 'right',
        paddingRight: '16px',
      },
    },
    tags: {
      [theme.breakpoints.down('Medium')]: {
        marginTop: '8px !important',
        marginBottom: '0 !important',
      },
    },
  }),
);

export default useEnumCharacteristicsIteratorStyles;
